module.exports = __webpack_public_path__ + "static/flags/TX-083020ef407c74bfac6e6277ae9e0ced.gif";